import { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../component/table/tableCustom';
import TableRowCommon from '../../../component/table/TableRowCommon';
import { Box, Dialog, DialogContent, DialogTitle, Grid, MenuItem, Typography } from '@mui/material';
import ButtonCustom from '../../../component/button/buttonCustom';
import { icons } from '../../../constants/images'
import InputTextField from '../../../component/input/inputTextField';
import FilterSelect from '../../../component/select/filterSelect';
import EmployeesApi from '../../../api/employees/employees.api';
import DepartmentApi from '../../../api/departments/departments.api';
import RoleApi from '../../../api/role/role.api';
import PositionApi from '../../../api/positions/positions.api';
import { LayoutTitle, LayoutView, TitleText } from '../../../component/layout/layoutMainStyle';
import { swalError, swalSuccess } from '../../../component/notification/swal';
import { useTranslation } from 'react-i18next';
import { Permission } from '../../../constants/permission';
import CheckboxPermission from '../../../component/checkboxPermission/checkboxPermission';
import { useSelector } from 'react-redux';
import InputPasswordField from '../../../component/input/inputPasswordField';
import ClearIcon from '@mui/icons-material/Clear';


const initStateErrorMessage = {
    TITLE: "",
    EMPLOYEES_F_NAME: "",
    EMPLOYEES_L_NAME: "",
    EMAIL: "",
    PASSWORD: "",
    DEPARTMENT: "",
    ROLE: "",
    POSITION: "",
    MOBILE: ""
};

interface Action {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

interface Role {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

export default function ListEmployees() {
    const { profile } = useSelector((state: any) => state.profile)
    const permit = profile?.permission || []
    const { t } = useTranslation();
    const [sortBy, setSortBy] = useState<string>('')
    const [sortType, setSortType] = useState<string>('ASC')
    const [data, setData] = useState<any>([])
    const [permission, setPermission] = useState<Role[]>(Permission);
    const [departments, setDepartments] = useState<any>([])
    const [roles, setRoles] = useState<any>([])
    const [positions, setPositions] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);
    const [input, setInput] = useState<any>({
        title: '',
        employeeFirstname: '',
        employeeLastname: '',
        email: '',
        password: '',
        idDepartment: null,
        idRole: null,
        idPosition: null,
        tel: '',
        fax: '',
        status: 'เปิดใช้งาน'
    })
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [rowCount, setRowCount] = useState<number>();
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItem, setTotalItem] = useState<number>();
    const [search, setSearch] = useState<string>('');
    const [open, setOpen] = useState<boolean>(false);
    const onRequestSort = (sortBy: string, sortType: string) => {
        setSortType(sortType)
        setSortBy(sortBy)
    }
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        clearErrorMessage();
        setInput({
            title: '',
            employeeFirstname: '',
            employeeLastname: '',
            email: '',
            password: '',
            idDepartment: null,
            idRole: null,
            idPosition: null,
            fax: '',
            tel: '',
            employeeStatus: 'เปิดใช้งาน'
        })
        setPermission(Permission)
    };
    ///// function checkbox /////////////

    const handleCheckboxChange = (node: any, checked: boolean) => {
        const updatedData = updateData([...permission], node, checked);
        setPermission(updatedData);
    };
    const updatePermit = (data: any, checked: boolean) => {
        return data.map((item: any) => {
            const updatedItem = { ...item, permit: checked };
            if (item.actions && item.actions.length > 0) {
                updatedItem.actions = updatePermit(item.actions, checked);
            }
            return updatedItem;
        });
    };
    const updateData = (arr: any, targetNode: any, checked: boolean) => {
        return arr.map((node: any) => {
            if (node.name === targetNode.name) {
                return { ...node, permit: checked, actions: checked ? targetNode.actions : updatePermit(node.actions, false) };
            } else if (node.actions && node.actions.length > 0) {
                return { ...node, actions: updateData(node.actions, targetNode, checked) };

            }
            return node;
        });
    };

    const updateAll = (data: any) => {
        setPermission(updatePermit(data, true))
    }

    ////////////////////////////////

    const getRole = async (id: number) => {
        RoleApi.getRole({ idRole: id }).then((res) => {
            if (res?.data?.success) {
                const data = res.data.result;
                setPermission(data.permission);
            }
        })
    }
    const getRoles = async () => {
        RoleApi.getRoles({}).then((res) => {
            if (res?.data?.success) {
                const { items } = res.data.result;
                setRoles(items);
            }
        })
    }
    const getEmployee = async (idEmployee: number) => {
        EmployeesApi.getEmployee(idEmployee).then((res) => {
            if (res?.data?.success) {
                const data = res.data.result;
                setInput(data);
                setPermission(data.permission)
            }
        })
    }
    const getPositions = async () => {
        PositionApi.getPositions({}).then((res) => {
            if (res?.data?.success) {
                const { items } = res.data.result;
                setPositions(items);
            }
        })
    }
    const getDepartments = async () => {
        DepartmentApi.getDepartments({}).then((res) => {
            if (res?.data?.success) {
                const { items } = res.data.result;
                setDepartments(items);
            }
        })
    }
    useEffect(() => {
        if (open) {
            getDepartments()
            getRoles()
            getPositions()
        }
    }, [open])


    const loadData = useCallback(async () => {
        let condition: any = {};
        if (page) condition = { ...condition, page: page };
        if (pageLimit) condition = { ...condition, limit: pageLimit };
        if (sortBy) condition = { ...condition, sortBy: sortBy };
        if (sortType) condition = { ...condition, sortType: sortType };
        if (search) condition = { ...condition, keyword: search };
        EmployeesApi.getEmployees(condition).then((res) => {
            if (res?.data?.success) {
                const { items, meta } = res.data.result;
                setData(items);
                setPage(meta.currentPage)
                setRowCount(meta.totalItems)
                setTotalItem(meta.totalItems)
                setTotalPages(meta.totalPages)
            }
        });
    }, [page, pageLimit, sortBy, sortType, search]);

    const postData = async () => {
        if (!input.title)
            return setErrorMessage({
                ...errorMessage,
                ...{ TITLE: t('EMPLOYEES_CREATE.MESSAGE.TITLE') },
            });
        if (!input.employeeFirstname)
            return setErrorMessage({
                ...errorMessage,
                ...{ EMPLOYEES_F_NAME: t('EMPLOYEES_CREATE.MESSAGE.EMPLOYEES_F_NAME') },
            });
        if (!input.employeeLastname)
            return setErrorMessage({
                ...errorMessage,
                ...{ EMPLOYEES_L_NAME: t('EMPLOYEES_CREATE.MESSAGE.EMPLOYEES_L_NAME') },
            });
        if (!input.idRole)
            return setErrorMessage({
                ...errorMessage,
                ...{ ROLE: t('EMPLOYEES_CREATE.MESSAGE.ROLE') },
            });
        if (!input.idDepartment)
            return setErrorMessage({
                ...errorMessage,
                ...{ DEPARTMENT: t('EMPLOYEES_CREATE.MESSAGE.DEPARTMENT') },
            });

        if (!input.idPosition)
            return setErrorMessage({
                ...errorMessage,
                ...{ POSITION: t('EMPLOYEES_CREATE.MESSAGE.POSITION') },
            });
        if (!input?.idEmployee && !input.password)
            return setErrorMessage({
                ...errorMessage,
                ...{ PASSWORD: t('EMPLOYEES_CREATE.MESSAGE.PASSWORD') },
            });
        if (!input.tel)
            return setErrorMessage({
                ...errorMessage,
                ...{ MOBILE: t('EMPLOYEES_CREATE.MESSAGE.MOBILE') },
            });
        if (!input.email.includes('@'))
            return setErrorMessage({
                ...errorMessage,
                ...{ EMAIL: t('EMPLOYEES_CREATE.MESSAGE.EMAIL') },
            });

        const body = {
            ...input,
            permission: permission
        }
        if (input?.idEmployee) {
            setLoading(true)
            await EmployeesApi.patchEmployees(input?.idEmployee, body).then((res) => {
                if (res?.data?.success) {
                    setLoading(false)
                    handleClose()
                    swalSuccess(t('EMPLOYEES_CREATE.SWAL.EDIT_SUCCESS'))

                } else {
                    setLoading(false)
                    swalError(res.response.data.description || res.response.data.message);
                }

            }).catch((error: any) => {
                setLoading(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        } else {
            setLoading(true)

            await EmployeesApi.postEmployees(body).then((res) => {
                console.log(res);
                if (res?.data?.success) {
                    setLoading(false)
                    handleClose()
                    swalSuccess(t('EMPLOYEES_CREATE.SWAL.CREATE_SUCCESS'))
                } else {
                    setLoading(false)
                    swalError(res.response.data.description || res.response.data.message);

                }
            }).catch((error: any) => {
                setLoading(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        }
    }
    const changeStatus = async (value: string, objData: any) => {
        await EmployeesApi.patchEmployees(objData?.idEmployee, { ...objData, employeeStatus: value }).then((res) => {
            if (res?.data?.success) {
                swalSuccess(t('EMPLOYEES_CREATE.SWAL.EDIT_STATUS_SUCCESS'))
                loadData()
            } else {
                swalError(res.response.data.description || res.response.data.message);

            }

        }).catch((error: any) => {
            swalError(error.response.data.description || error.response.data.message);
        })
    }


    useEffect(() => {
        loadData()
    }, [loadData])

    const headCells = [
        {
            id: "employeeFirstname",
            label: t('EMPLOYEES.HEADCELL.NAME'),
            align: "left",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "idPosition",
            label: t('EMPLOYEES.HEADCELL.POSITION'),
            align: "left",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "idDepartment",
            label: t('EMPLOYEES.HEADCELL.DEPARTMENT'),
            align: "left",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "employeeStatus",
            label: t('EMPLOYEES.HEADCELL.STATUS'),
            align: "center",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            colSpan: 1,
        },
    ];


    const renderData = (objData: any, index: any) => {
        const { employeeFirstname, employeeLastname, Department, Position, employeeStatus, idEmployee } = objData;
        index = page * pageLimit - pageLimit + index + 1;

        const objRenderData = {
            key: index,
            id: idEmployee,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: `${employeeFirstname} ${employeeLastname}` },
                { option: "TEXT", align: "left", label: Position.positionName },
                { option: "TEXT", align: "left", label: Department.departmentName },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <>
                            <FilterSelect
                                disabled={!permit.find((x: any) => x?.code === 'Employees.Read')?.permit}
                                labelId='' selectId='' style={{
                                    '& .MuiSelect-select': {
                                        backgroundColor: employeeStatus === 'เปิดใช้งาน' ? '#F3FFF6' : '#ffe4e4',
                                        color: employeeStatus === 'เปิดใช้งาน' ? '#2AA63C' : '#ff0000',
                                        margin: '0px 30px 0px 6px',
                                        padding: '5px 0px',
                                    }
                                }} options={[{ value: 'เปิดใช้งาน', name: t('EMPLOYEES.STATUS.ACTIVE') }, { value: 'ไม่ใช้งาน', name: t('EMPLOYEES.STATUS.UNACTIVE') }].map((x, i) => {
                                    return (
                                        <MenuItem key={i}
                                            value={x.value}
                                            sx={{
                                                backgroundColor: x.value === 'เปิดใช้งาน' ? '#F3FFF6' : '#ffe4e4',
                                                color: x.value === 'เปิดใช้งาน' ? '#2AA63C' : '#ff0000',
                                            }}
                                        >
                                            ● {x.name}
                                        </MenuItem>
                                    )
                                })} value={employeeStatus} onchange={(e: any) => { changeStatus(e.target.value, objData) }} />
                        </>
                    )
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <>
                            {permit.find((x: any) => x?.code === 'Employees.Read')?.permit && <icons.dotMenu onClick={() => {
                                handleClickOpen()
                                getEmployee(idEmployee)
                            }} style={{ cursor: "pointer" }} />}
                        </>
                    )
                }

            ],

        }


        return (
            <TableRowCommon
                {...objRenderData}
                ondocumentdetail={() => { }}
            />
        )
    };


    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>{t('EMPLOYEES.TITLE')}</TitleText>

                <div className='d-flex gap-2'>
                    <InputTextField placeholder='ค้นหา' value={search} onchange={(e) => setSearch(e.target.value)} />
                    {permit.find((x: any) => x?.code === 'Employees.Add')?.permit && <ButtonCustom variant={'outlined'}
                        startIcon={<icons.circleButton />}
                        textButton={t('EMPLOYEES.BUTTON.CREATE')}
                        onClick={() => handleClickOpen()} />}
                </div>
            </LayoutTitle>
            <TableCustom
                headCells={headCells}
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortType={sortType}
                sortBy={sortBy}
                rowCount={rowCount}
                rowsData={data?.map((d: any, index: any) => {
                    return renderData(d, index);
                })}
                onSort={onRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
                totalPages={totalPages}
                totalItem={totalItem}
            />
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                fullWidth
                maxWidth='md'
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end', position: 'absolute', top: '10px', right: "10px" }}>
                    <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => {
                        handleClose()
                    }} />
                </DialogTitle>
                <DialogContent sx={{ padding: '32px', marginTop: "24px", gap: '32px', display: 'flex', flexDirection: "column" }}>
                    <div style={{ display: "flex", justifyContent: 'center', width: '100%' }}>
                        <TitleText>{t('EMPLOYEES_CREATE.TITLE')}</TitleText>
                    </div>
                    <Grid container spacing={1}>
                        <Grid item md={2} xs={12}>
                            <FilterSelect heading={t('EMPLOYEES_CREATE.INPUT.TITLE')} labelId='' selectId='' options={[{ value: 'นาย', name: 'นาย' }, { value: 'นาง', name: 'นาง' }, { value: 'นางสาว', name: 'นางสาว' },].map((x, i) => {
                                return (
                                    <MenuItem key={i}
                                        value={x.value}
                                    >
                                        {x.name}
                                    </MenuItem>
                                )
                            })} value={input.title} onchange={(event: any) => {
                                setInput({ ...input, title: event.target.value });
                                clearErrorMessage();
                            }}
                                helperText={
                                    errorMessage.TITLE || ''
                                } /></Grid>
                        <Grid item md={5} xs={12}><InputTextField heading={t('EMPLOYEES_CREATE.INPUT.FNAME')} value={input.employeeFirstname} onchange={(event: any) => {
                            setInput({ ...input, employeeFirstname: event.target.value });
                            clearErrorMessage();
                        }}
                            helperText={
                                errorMessage.EMPLOYEES_F_NAME || ''
                            } /></Grid>

                        <Grid item md={5} xs={12}><InputTextField heading={t('EMPLOYEES_CREATE.INPUT.LNAME')} value={input.employeeLastname} onchange={(event: any) => {
                            setInput({ ...input, employeeLastname: event.target.value });
                            clearErrorMessage();
                        }}
                            helperText={
                                errorMessage.EMPLOYEES_L_NAME || ''
                            } /></Grid>
                        <Grid item md={6} xs={12}>
                            <FilterSelect heading={t('EMPLOYEES_CREATE.INPUT.ROLE')} labelId='' selectId='' options={roles.map((x: any, i: number) => {
                                return (
                                    <MenuItem key={i}
                                        disabled={x.roleStatus !== 'เปิดใช้งาน'}
                                        value={x.idRole}
                                    >
                                        {x.roleName}
                                    </MenuItem>
                                )
                            })} value={input.idRole} onchange={(event: any) => {
                                setInput({ ...input, idRole: event.target.value });
                                getRole(event.target.value)
                                clearErrorMessage();
                            }}
                                helperText={
                                    errorMessage.ROLE || ''
                                } />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FilterSelect heading={t('EMPLOYEES_CREATE.INPUT.DEPARTMENT')} labelId='' selectId='' options={departments?.map((x: any, i: number) => {
                                return (
                                    <MenuItem key={i}
                                        disabled={x.departmentStatus !== 'เปิดใช้งาน'}
                                        value={x.idDepartment}
                                    >
                                        {x.departmentName}
                                    </MenuItem>
                                )
                            })}
                                value={input.idDepartment}
                                onchange={(event: any) => {
                                    setInput({ ...input, idDepartment: event.target.value });
                                    clearErrorMessage();
                                }}
                                helperText={
                                    errorMessage.DEPARTMENT || ''
                                } />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FilterSelect heading={t('EMPLOYEES_CREATE.INPUT.POSITION')} labelId='' selectId='' options={positions.map((x: any, i: number) => {
                                return (
                                    <MenuItem key={i}
                                        disabled={x.positionStatus !== 'เปิดใช้งาน'}
                                        value={x.idPosition}
                                    >
                                        {x.positionName}
                                    </MenuItem>
                                )
                            })}
                                value={input.idPosition}
                                onchange={(event: any) => {
                                    setInput({ ...input, idPosition: event.target.value });
                                    clearErrorMessage();
                                }}
                                helperText={
                                    errorMessage.POSITION || ''
                                } /></Grid>
                        <Grid item md={6} xs={12}>
                            <InputPasswordField inputProps={
                                { startAdornment: null }
                            } heading={t('EMPLOYEES_CREATE.INPUT.PASSWORD')} value={input.password} onchange={(event: any) => {
                                setInput({ ...input, password: event.target.value });
                                clearErrorMessage();
                            }}
                                helperText={
                                    errorMessage.PASSWORD || ''
                                } /></Grid>
                        <Grid item md={6} xs={12}><InputTextField heading={t('EMPLOYEES_CREATE.INPUT.TEL')} value={input.tel} onchange={(event: any) => {
                            setInput({ ...input, tel: event.target.value });
                            clearErrorMessage();
                        }}
                            helperText={
                                errorMessage.MOBILE || ''
                            } /></Grid>
                        <Grid item md={6} xs={12}><InputTextField heading={t('EMPLOYEES_CREATE.INPUT.FAX')} value={input.fax} onchange={(event: any) => {
                            setInput({ ...input, fax: event.target.value });
                            // clearErrorMessage();
                        }} /></Grid>
                        <Grid item xs={12}><InputTextField heading={t('EMPLOYEES_CREATE.INPUT.EMAIL')} value={input.email} onchange={(event: any) => {
                            setInput({ ...input, email: event.target.value });
                            clearErrorMessage();
                        }}
                            helperText={
                                errorMessage.EMAIL || ''
                            } /></Grid>
                    </Grid>
                    <Typography variant='h6' sx={{ margin: "22px 0px", fontWeight: '500' }}>กำหนดฟังก์ชัน</Typography>
                    <ButtonCustom textButton={'เลือกทั้งหมด'} onClick={() => updateAll(permission)} />

                    <Box sx={{
                        margin: '20px 0',
                    }}>

                        {
                            permission.map((node, i) => (
                                <CheckboxPermission
                                    key={node.name}
                                    node={node}
                                    onCheckboxChange={handleCheckboxChange}

                                />

                            ))
                        }

                    </Box>
                    <ButtonCustom textButton={t('EMPLOYEES_CREATE.BUTTON.SUBMMIT')} disabled={loading} style={{ margin: "auto" }} onClick={() => postData()} />
                </DialogContent>

            </Dialog>
        </LayoutView >
    )
}
